import React from "react";
import { useSelector } from "react-redux";
import DiagramContainer from "./components/Container.js";

export function Diagram() {
  const { lang } = useSelector((state) => state);

  return (
    <div class="midde_cont">
      <div class="container-fluid">
        <div class="row column_title">
          <div class="col-md-12">
            <div class="page_title ">
              <h4 class="ml-1">{lang["diagram"]}</h4>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <div class="white_shd full margin_bottom_30">
              <div class={`table_section padding_infor_info`}>
                <div class={`row column1`}>
                  <DiagramContainer />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
